// Studio's words for outcomes and demand, in one place. The words follow
// Design > Names and definitions, "Curator Studio words".

import type { ChartTone, FeedbackTone } from "../../../ui/src/index.ts";
import type { OutcomeKey } from "../domain/activity.ts";
import type { DemandGroup } from "../domain/demand.ts";

export const OUTCOME_WORDS: Record<OutcomeKey, string> = {
  answered: "Answered", detail: "Needed a detail", declined: "Declined", planned: "Planned question",
  pricedOut: "Priced out", notFound: "Found nothing", error: "Error",
};
export const OUTCOME_TONES: Record<OutcomeKey, ChartTone> = {
  answered: "success", detail: "info", declined: "neutral", planned: "violet", pricedOut: "pink", notFound: "muted", error: "danger",
};
export const BADGE_TONES: Record<OutcomeKey, FeedbackTone> = {
  answered: "success", detail: "info", declined: "neutral", planned: "neutral", pricedOut: "neutral", notFound: "neutral", error: "danger",
};
export const GROUP_WORDS: Record<DemandGroup, string> = { declined: "Declined", outranked: "Matched but not sent", missed: "Missed" };
export const GROUP_HELP: Record<DemandGroup, string> = {
  declined: "These asks were outside the hub's scope. Each can still cost the hub its router model call.",
  outranked: "These matched one of the hub's questions, but the Exchange dispatched the ask to a hub ranked higher.",
  missed: "These scored below the hub's dispatch threshold, or were near misses at the fallback cutoff, so they weren't dispatched to the hub.",
};

export const capitalize = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);
export const shortCommit = (commit: string) => commit.slice(0, 7);
export const day = (ms: number) => new Date(ms).toLocaleDateString("en-US", { day: "numeric", month: "short" });
export const dayTime = (ms: number) => new Date(ms).toLocaleString("en-US", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit", hour12: false });
